/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2024, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// Copied from:
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/hooks/useApi.js

// Data Hook Generator
// import useDataHook from "src/api-helpers";
import useDataHook from "@console/cloud-pal-community/api-helpers";

// Config file
import config from "./useApiConfig";

// By default we export the data hook
export default useDataHook(config);